import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ScanProduct } from '../models/scan-product.model';

@Injectable({
  providedIn: 'root',
})
export class ScanService {
  constructor(private readonly http: HttpClient) {}
  private baseUrl: string = environment.inventoryApiUrl;

  ValidateScanProduct(data: ScanProduct) {
    const url = `${this.baseUrl}/Products/Scan`;
    return this.http.post(url, data);
  }
}
